// extracted by mini-css-extract-plugin
module.exports = {"storyHeader":"storyContent_storyHeader__FGBey"};